/*
 * @Description:
 * @Author: 诺
 * @Date: 2021-12-22 21:17:18
 * @LastEditors: 诺
 * @LastEditTime: 2022-04-21 15:44:15
 */
import axios from "axios";
const host=process.env.VUE_APP_BASEAPI
import Vue from 'vue/dist/vue.js';
let _options = {};
import util from '@/utils/common';

import {  MessageBox,Indicator } from "mint-ui";
import sign from '@/utils/sign'
let  isShowError = false;
/**
 * 显示错误信息
 * @param {string} message 错误内容
 */
const ShowErrorMessage = (message) => {
  if (!isShowError) {
    isShowError = true;
    MessageBox({
      message,
      type: "error",
      duration: 5 * 1000,
    });
    const shutTimer = setTimeout(() => {
      isShowError = false;
      clearTimeout(shutTimer);
    }, 1900);
  }
};

const service = axios.create({
  baseURL: host,
  timeout: 600000,
});

service.interceptors.request.use(
  (config) => {

    config.baseURL = host;
    
    Indicator.open();
    return config;
  },
  (error) => {
    Indicator.close();
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    Indicator.close();
    let res = response.data;

    if (typeof res == "string" && res.length > 0) res = JSON.parse(res);

    const message =
      res.msg ||
      res.errmsg ||
      res.message ||
      `返回错误${res.code} ${res.obj}` ||
      `${res.code}-接口或传参数错误`;
    if (![0, 200, -1033,9997,8886,8884,8883,8890,8891].includes(res.code)) {
      // code为200或0表示，接口请求成功！
      res.msg = message;
      res.result = false;
      ShowErrorMessage(message || "网络或接口故障！");
      return res;
    } else {
      //统一打结构true标记
      res.result = true;
      return res;
    }
  },
  (error) => {
    Indicator.close();
    ShowErrorMessage(error.msg || "网络或接口故障！");
    return Promise.reject(error);
  }
);


/**
 * 接口通用ContentType类型
 */
 const contentTypeLib = {
  'json': 'application/json;charset=UTF-8',
  'form': 'application/x-www-form-urlencoded;charset=UTF-8',
  'formData': "multipart/form-data"
}
const requestRestFul = (url = '', data = {},  method = 'get', contentType = 'json',headers = {}) => {
 
  const md=typeof url== "object" ?url.method:method;
  let options = {
    url:typeof url== "object" ?url.api:url,
    method:md,
    headers: {},
  }
  if(!Vue.prototype.$projectId && util.cookie.get("configInfo")){
    Vue.prototype.$projectId=JSON.parse(util.cookie.get("configInfo")).projectId
  }
  let header={
    // actCode  openId  fromOpenId  fromSaleOpenId  channelId  projectId  appId
    actCode:Vue.prototype.$actCode||'',
    openId:Vue.prototype.$openid||'',
    fromOpenId:Vue.prototype.$fopenid||'',
    fromSaleOpenId:Vue.prototype.$fromSaleOpenId||'',
    channelId:Vue.prototype.$channel||1,
    projectId:Vue.prototype.$projectId||'',
    appId:Vue.prototype.$appId||'',
  }
    const Sign = new sign
    header={
      ...header,
      timestamp: Sign.timestamp,
      actSignKey: Sign.signKey,
      actSign: Sign.paySign('/' + (typeof url== "object" ?url.api:url)),
      version: Sign.version,
    }

  let conType=typeof url== "object" ?url.contentType:contentType;
  // console.log(conType)
  options.headers = { "client": "rushi", ...headers,...header }
  if (md.toLowerCase() === 'get') {
    options['params'] = data
  } else if (md.toLowerCase() === 'post') {
    if (conType == 'form') {
      options['params'] = data
    } else {
      options['data'] = JSON.stringify(data)
    }
    options.headers['Content-Type'] = contentTypeLib[conType]
  }
  if(typeof url== "object"&&url.type=='query'){
    options['url']=url.api+`?${util._openInterceptor(data)}`
  }
  if(typeof url== "object"&&url.type=='path'){
    options['url']=url.api+`/${util._openInterceptor(data)}`
  }
  return service(options)
}
const requestRestFul2 = (param, data = {}, headers = {}) => {
  let options = {
    url:typeof param== "object" ?param.api:param,
    method:param.method,
    headers: {},
  }
  if(!Vue.prototype.$projectId && util.cookie.get("configInfo")){
    Vue.prototype.$projectId=JSON.parse(util.cookie.get("configInfo")).projectId
  }
  let header={
    // actCode  openId  fromOpenId  fromSaleOpenId  channelId  projectId  appId
    actCode:Vue.prototype.$actCode||'',
    openId:Vue.prototype.$openid||'',
    fromOpenId:Vue.prototype.$fopenid||'',
    fromSaleOpenId:Vue.prototype.$fromSaleOpenId||'',
    channelId:Vue.prototype.$channel||1,
    projectId:Vue.prototype.$projectId||'',
    appId:Vue.prototype.$appId||'',
  }

  const Sign = new sign
  header={
    ...header,
    timestamp: Sign.timestamp,
    actSignKey: Sign.signKey,
    actSign: Sign.paySign('/' +(typeof param== "object" ?param.api:param)),
    version: Sign.version,
  }
  console.log(header)
  
  options.headers = { "client": "rushi", ...headers,...header }
  if (param.method.toLowerCase() === 'get') {
    options['params'] = data
  } else if (param.method.toLowerCase() === 'post') {
    if (param.contentType == 'form') {
      options['params'] = data
    } else {
      options['data'] = JSON.stringify(data)
    }
    options.headers['Content-Type'] = contentTypeLib[param.contentType]
  }
  return service(options)
}

export default {
  options:_options,
  requestRestFul,requestRestFul2
}